import { useEffect } from 'react';
import { authAPI } from '../../api';
import { useUserAuthStore } from '../../stores/global/userAuth';
import { useNotificationsStore } from '../../stores/global/notifications';
import CommonConstants from '../constants';
import { usePageLoader } from '../contexts/page_content_context';

export function usePendingNotifications() {
  const token = useUserAuthStore((state) => state.token);
  const idUsuario = useUserAuthStore((state) => state.idUsuario);
  const empresaId = useUserAuthStore((state) => state.empresaId);
  const { pushWarnNotification } = usePageLoader();

  useEffect(() => {
    if (!token) return;

    useNotificationsStore.getState().setOwner(`${empresaId}:${idUsuario}`);
    let stopped = false;
    let inFlight = false;
    let timer: number | undefined;
    let controller: AbortController | undefined;
    let failures = 0;
    let nextCheck = 0;
    const interval = CommonConstants.checkNotificationTimeInSeconds * 1000;

    const check = async () => {
      if (stopped || inFlight || document.hidden || !navigator.onLine) return;
      window.clearTimeout(timer);
      inFlight = true;
      controller = new AbortController();
      try {
        const response = await authAPI.getNotifications(controller.signal);
        if (stopped || useUserAuthStore.getState().token !== token) return;
        if (response.statusCode === 200 && response.data) {
          failures = 0;
          const newCount = useNotificationsStore.getState().sync(response.data.itens ?? []);
          if (newCount > 0) {
            pushWarnNotification('Alertas pendentes', 'Existem novos alertas que precisam da sua atenção, clique no sino para vê-los.');
          }
        } else {
          failures += 1;
        }
      } catch {
        failures += 1;
      } finally {
        inFlight = false;
        if (!stopped && useUserAuthStore.getState().token === token) {
          const delay = interval * Math.min(2 ** failures, 8);
          nextCheck = Date.now() + delay;
          timer = window.setTimeout(check, delay);
        }
      }
    };

    const resume = () => {
      if (!document.hidden && navigator.onLine && Date.now() >= nextCheck) void check();
    };
    void check();
    document.addEventListener('visibilitychange', resume);
    window.addEventListener('online', resume);
    return () => {
      stopped = true;
      window.clearTimeout(timer);
      controller?.abort();
      document.removeEventListener('visibilitychange', resume);
      window.removeEventListener('online', resume);
    };
  }, [token, idUsuario, empresaId, pushWarnNotification]);
}
